/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetUserSession200ResponseAllOfData } from './GetUserSession200ResponseAllOfData';
import {
    GetUserSession200ResponseAllOfDataFromJSON,
    GetUserSession200ResponseAllOfDataFromJSONTyped,
    GetUserSession200ResponseAllOfDataToJSON,
} from './GetUserSession200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetUserSession200Response
 */
export interface GetUserSession200Response {
    /**
     * 
     * @type {GetUserSession200ResponseAllOfData}
     * @memberof GetUserSession200Response
     */
    data: GetUserSession200ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof GetUserSession200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the GetUserSession200Response interface.
 */
export function instanceOfGetUserSession200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function GetUserSession200ResponseFromJSON(json: any): GetUserSession200Response {
    return GetUserSession200ResponseFromJSONTyped(json, false);
}

export function GetUserSession200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserSession200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetUserSession200ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function GetUserSession200ResponseToJSON(value?: GetUserSession200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetUserSession200ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

